import { forwardRef } from 'react';
import type { AppSelectComponent } from '../Base/SelectBase.types';
import type { AppMultipleSelectProps } from './MultipleSelect.types';
import { AppSelectBase } from '../Base/SelectBase';

export const AppMultipleSelect = forwardRef<AppSelectComponent, AppMultipleSelectProps>(
  (props, ref) => {
    return <AppSelectBase {...props} mode="multiple" ref={ref} />;
  },
);
